import request from "@/utils/request";

// 绩效考核列表
export function loadPerformanceAppraisalListDataApi(data) {
  return request({
    url: "web/outsideUserStatistics/listPerformanceAppraisal",
    method: "post",
    data
  });
}
// 绩效考核导出
export function loadPerformanceAppraisalExportDataApi(data) {
  return request({
    url: "web/outsideUserStatistics/exportPerformanceAppraisal",
    method: "post",
    data
  });
}
// 零售户档案统计列表
export function loadOutsideStoreStatisticsListDataApi(data) {
  return request({
    url: "web/outsideUserStatistics/listOutsideStoreStatistics",
    method: "post",
    data
  });
}
// 零售户档案统计导出
export function loadOutsideStoreStatisticsExportDataApi(data) {
  return request({
    url: "web/outsideUserStatistics/exportOutsideStoreStatistics",
    method: "post",
    data
  });
}
// 外勤工作日志表列表
export function loadOutsideWorkLogListDataApi(data) {
  return request({
    url: "web/outsideUserStatistics/listOutsideWorkLog",
    method: "post",
    data
  });
}
// 月度活动考勤表列表
export function loadActivityUserByYearMonthListDataApi(data) {
  return request({
    url: "web/outsideUserStatistics/listActivityUserByYearMonth",
    method: "post",
    data
  });
}
// 月度推广人员考勤表列表
export function loadActivityUserWorkDayByYearMonthListDataApi(data) {
  return request({
    url: "web/outsideUserStatistics/listActivityUserWorkDayByYearMonth",
    method: "post",
    data
  });
}